import { Component, Input } from '@angular/core';
import { FileService } from 'src/app/core/services/file.service';

@Component({
  selector: 'app-custom-image',
  templateUrl: './custom-image.component.html',
  styleUrls: ['./custom-image.component.scss'],
})
export class CustomImageComponent {
  @Input({ required: true }) src = '';
  @Input({ required: true }) alt = '';

  @Input() class = '';
  @Input() imageClass = '';
  imageLoader = true;

  constructor(public fileService: FileService) {}

  ngOnChanges() {
    if (!this.src) {
      this.src = this.fileService.getDefaultImg();
      return;
    }
    if (this.fileService.isYoutubeUrl(this.src)) {
      const id = this.fileService.getYoutubeId(this.src);
      this.src = this.fileService.getThumbnailYoutube(id);
    } else if (this.fileService.isVideoUrl(this.src)) {
      this.src = this.fileService.convertWebmToWebp(this.src);
    } else {
      this.src = this.fileService.getThumbnailWebp(this.src);
    }
  }

  onImageError() {
    this.imageLoader = false;
    this.src = this.fileService.getDefaultImg();
  }

  onImageLoad() {
    this.imageLoader = false;
  }
}
